import styled, {css, keyframes} from 'styled-components';

export const UploadLabel = styled.label(
  props =>`
  width: 100%;
  display: flex;
  border: 1px dashed ${props.theme.colors.blue.light36};
  background-color: ${props.theme.colors.blue.light06};
  height: 4.2rem;
  border-radius: ${props.theme.misc.borderRadius.base};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: ${props.theme.spacing.base};
    width: 100%;
    margin-left: 0rem;
    height: 6rem;
  }
  opacity: ${props.disabled ? '0.2' : '1'};
  pointer-events: ${props.disabled ? 'none' : ''};
`);

export const FullDiv = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const UploadImgMainText = styled.p(
  props => `
        display:inline-block;
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        text-align:center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width:95%;
    `,
);

export const BoldText = styled.span(
  props => `
        font-weight: ${props.theme.font.fontWeight.black};
        padding-left: ${props.theme.spacing.small.s3};
        padding-right: ${props.theme.spacing.small.s3};
    `,
);

export const SubInfoText = styled.span(
  props => `
        font-size: 1.2rem ${props.theme.font.base};
        color: ${props.theme.colors.grey.light07};
        padding-top:${props.theme.spacing.small.s3};
    `,
);

export const UploadFile = styled.input.attrs({type: 'file'})(
  props => `
        width:100%;
        display: flex;
        -webkit-appearance:none;
        display:none;
    `,
);

export const UploadedFileInfo = styled.div(
  props =>`
  width: 50%;
  display: flex;
  border: 1px dashed ${props.theme.colors.black.light36};
  background-color: ${props.theme.colors.grey.light46};
  height: 4.2rem;
  margin-left: ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: ${props.theme.spacing.base};
    width: 100%;
    margin-left: ${props.theme.spacing.nospacing};
    height: 6rem;
  }
`);

export const ImageInfoWrap = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled.p(
  props =>`
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: ${props.theme.colors.grey.lighte5};
  right: 0.2rem;
  top: 0.2rem;
  border-radius: ${props.theme.misc.borderRadius.round};
  font-size: ${props.theme.font.large.font13};
  color: ${props.theme.colors.black.base};
  padding-bottom: ${props.theme.spacing.small.s3};
  cursor: pointer;
`);

export const KYCUploadLabel = styled.label(
  props =>`
  width: 100%;
  display: flex;
  border: 1px dashed ${props.theme.colors.blue.light36};
  background-color: ${props.theme.colors.blue.light06};
  height: 4.2rem;
  border-radius: ${props.theme.misc.borderRadius.base};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: ${props.theme.spacing.base};
    width: 100%;
    margin-left: 0rem;
    height: 6rem;
  }
`);

export const DocumentTickWrap = styled.div(
  props =>`
  width: 1.4rem;
  height: 1.4rem;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.green.base};
  position: absolute;
  z-index: ${props.theme.misc.zIndex.xxlarge};
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0.6rem;
  right: 43%;
`);
